var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.939,
    height: 52.584,
    viewBox: "0 0 195.939 52.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_neo",
    transform: "translate(-184.707 -164.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(252.508 204.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M414.253,291.757l-2.221,7.153h-1.2l-1.563-4.887a3.29,3.29,0,0,1-.119-.435q-.03.123-.059.232c-.02.072-.041.14-.064.2l-1.578,4.887H406.24l-2.216-7.153h1.113a.494.494,0,0,1,.289.082.393.393,0,0,1,.156.22l1.217,4.279q.039.158.077.344t.077.388c.026-.138.055-.269.087-.39s.065-.236.1-.341l1.4-4.279a.465.465,0,0,1,.156-.207.437.437,0,0,1,.284-.094h.391a.447.447,0,0,1,.282.084.514.514,0,0,1,.163.217l1.4,4.279a6.216,6.216,0,0,1,.188.707q.064-.39.143-.707l1.217-4.279a.372.372,0,0,1,.151-.213.477.477,0,0,1,.289-.089Z",
    transform: "translate(-404.024 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M440.848,292.816V294.8h2.5v1.024h-2.5v2.023h3.176v1.063h-4.511v-7.153h4.511v1.059Z",
    transform: "translate(-428.541 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M472.548,291.757v7.153h-1.172v-4.62q0-.277.03-.6l-2.162,4.061a.5.5,0,0,1-.47.292h-.188a.5.5,0,0,1-.47-.292l-2.186-4.076q.015.163.025.322c.007.106.01.2.01.292v4.62h-1.172v-7.153h1c.059,0,.11,0,.153,0a.413.413,0,0,1,.116.025.244.244,0,0,1,.094.064.547.547,0,0,1,.082.118l2.142,3.972q.084.159.156.327t.141.346c.046-.122.094-.24.144-.354s.1-.224.158-.329l2.112-3.962a.52.52,0,0,1,.084-.118.268.268,0,0,1,.1-.064.415.415,0,0,1,.116-.025c.043,0,.094,0,.153,0Z",
    transform: "translate(-446.006 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M498.811,298.91h-1.029a.441.441,0,0,1-.282-.087.54.54,0,0,1-.163-.215l-.534-1.459H493.84l-.534,1.459a.471.471,0,0,1-.153.208.429.429,0,0,1-.282.094h-1.038l2.815-7.153H496Zm-2.349-2.7-.871-2.379c-.043-.105-.087-.231-.134-.376s-.092-.3-.138-.47q-.064.252-.134.472t-.133.384l-.866,2.369Z",
    transform: "translate(-464.686 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M517.69,294.755H518a.816.816,0,0,0,.312-.052.532.532,0,0,0,.213-.166l1.973-2.5a.715.715,0,0,1,.26-.22.829.829,0,0,1,.344-.062h1.148l-2.409,2.973a1.346,1.346,0,0,1-.44.386,1.009,1.009,0,0,1,.294.166,1.3,1.3,0,0,1,.25.279l2.483,3.349h-1.172a.73.73,0,0,1-.354-.067.551.551,0,0,1-.2-.2l-2.023-2.641a.53.53,0,0,0-.218-.188.912.912,0,0,0-.356-.054h-.42v3.146h-1.331v-7.153h1.331Z",
    transform: "translate(-481.631 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M539.182,292.816V294.8h2.5v1.024h-2.5v2.023h3.175v1.063h-4.511v-7.153h4.511v1.059Z",
    transform: "translate(-496.476 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M565.451,291.757a4.078,4.078,0,0,1,1.242.168,2.384,2.384,0,0,1,.866.47,1.86,1.86,0,0,1,.507.722,2.488,2.488,0,0,1,.166.92,2.536,2.536,0,0,1-.173.952,1.973,1.973,0,0,1-.519.745,2.419,2.419,0,0,1-.868.484,3.87,3.87,0,0,1-1.219.173h-.994v2.518h-1.331v-7.153Zm0,3.6a2.007,2.007,0,0,0,.638-.092,1.211,1.211,0,0,0,.453-.262,1.064,1.064,0,0,0,.27-.416,1.589,1.589,0,0,0,.089-.546,1.442,1.442,0,0,0-.089-.519,1.026,1.026,0,0,0-.267-.4,1.189,1.189,0,0,0-.45-.25,2.125,2.125,0,0,0-.643-.087h-.994v2.567Z",
    transform: "translate(-513.94 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M588.516,291.757v7.153H587.18v-3.126h-3.358v3.126h-1.336v-7.153h1.336v3.077h3.358v-3.077Z",
    transform: "translate(-527.315 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M610.921,298.91h-1.029a.439.439,0,0,1-.282-.087.537.537,0,0,1-.163-.215l-.534-1.459H605.95l-.534,1.459a.471.471,0,0,1-.153.208.428.428,0,0,1-.282.094h-1.039l2.814-7.153h1.355Zm-2.35-2.7-.87-2.379q-.064-.158-.134-.376t-.138-.47q-.064.252-.134.472t-.134.384l-.866,2.369Z",
    transform: "translate(-542.138 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M634.053,298.91h-1.2a.528.528,0,0,1-.495-.267l-1.5-2.29a.523.523,0,0,0-.185-.183.647.647,0,0,0-.3-.054H629.8v2.795h-1.331v-7.153h2.181a4.527,4.527,0,0,1,1.249.151,2.387,2.387,0,0,1,.856.423,1.653,1.653,0,0,1,.492.65,2.14,2.14,0,0,1,.158.833,2.164,2.164,0,0,1-.106.683,1.977,1.977,0,0,1-.307.584,2.069,2.069,0,0,1-.495.46,2.483,2.483,0,0,1-.67.311,1.32,1.32,0,0,1,.237.176,1.245,1.245,0,0,1,.2.24Zm-3.423-3.749a2.057,2.057,0,0,0,.655-.094,1.264,1.264,0,0,0,.46-.259,1.048,1.048,0,0,0,.27-.393,1.362,1.362,0,0,0,.089-.5,1.016,1.016,0,0,0-.359-.836,1.715,1.715,0,0,0-1.1-.292H629.8v2.375Z",
    transform: "translate(-559.083 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M656.353,291.757v7.153h-1.172v-4.62q0-.277.03-.6l-2.162,4.061a.5.5,0,0,1-.47.292h-.188a.5.5,0,0,1-.47-.292l-2.186-4.076c.01.109.018.216.025.322s.01.2.01.292v4.62H648.6v-7.153h1c.059,0,.11,0,.153,0a.416.416,0,0,1,.116.025.247.247,0,0,1,.094.064.559.559,0,0,1,.082.118l2.142,3.972q.084.159.156.327c.048.112.095.227.141.346q.069-.183.143-.354t.158-.329l2.112-3.962a.5.5,0,0,1,.084-.118.267.267,0,0,1,.1-.064.414.414,0,0,1,.116-.025c.043,0,.094,0,.153,0Z",
    transform: "translate(-572.988 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M682.616,298.91h-1.029a.439.439,0,0,1-.282-.087.542.542,0,0,1-.164-.215l-.534-1.459h-2.963l-.534,1.459a.471.471,0,0,1-.153.208.428.428,0,0,1-.282.094h-1.039l2.815-7.153h1.355Zm-2.349-2.7-.871-2.379q-.064-.158-.134-.376t-.138-.47q-.064.252-.134.472t-.133.384l-.866,2.369Z",
    transform: "translate(-591.669 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M708.883,291.757a4.705,4.705,0,0,1,1.2.134,2.293,2.293,0,0,1,.819.381,1.48,1.48,0,0,1,.467.6,2.017,2.017,0,0,1,.148.791,1.563,1.563,0,0,1-.074.483,1.4,1.4,0,0,1-.23.43,1.723,1.723,0,0,1-.4.363,2.385,2.385,0,0,1-.571.277q1.474.332,1.474,1.593a2.03,2.03,0,0,1-.173.841,1.848,1.848,0,0,1-.5.665,2.4,2.4,0,0,1-.816.438,3.558,3.558,0,0,1-1.108.159h-2.7v-7.153Zm-1.133,1.029v2.068h1.058a1.781,1.781,0,0,0,1.031-.247.9.9,0,0,0,.349-.786.931.931,0,0,0-.317-.8,1.655,1.655,0,0,0-.989-.238Zm1.345,5.085a1.889,1.889,0,0,0,.623-.089,1.079,1.079,0,0,0,.4-.237.869.869,0,0,0,.218-.347,1.3,1.3,0,0,0,.067-.42,1.115,1.115,0,0,0-.074-.418.78.78,0,0,0-.232-.317,1.082,1.082,0,0,0-.408-.2,2.265,2.265,0,0,0-.6-.069h-1.34v2.1Z",
    transform: "translate(-612.935 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M728.38,292.816V294.8h2.5v1.024h-2.5v2.023h3.175v1.063h-4.511v-7.153h4.511v1.059Z",
    transform: "translate(-627.184 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M748.544,292.85h-2.157v6.06h-1.331v-6.06H742.9v-1.093h5.644Z",
    transform: "translate(-638.138 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M767.3,292.85h-2.157v6.06h-1.331v-6.06h-2.157v-1.093H767.3Z",
    transform: "translate(-651.093 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M783.835,292.816V294.8h2.5v1.024h-2.5v2.023h3.176v1.063H782.5v-7.153h4.511v1.059Z",
    transform: "translate(-665.496 -291.757)",
    fill: "#05c6a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M806.036,298.91h-1.2a.528.528,0,0,1-.495-.267l-1.5-2.29a.526.526,0,0,0-.186-.183.646.646,0,0,0-.3-.054h-.569v2.795h-1.33v-7.153h2.181a4.524,4.524,0,0,1,1.249.151,2.382,2.382,0,0,1,.856.423,1.65,1.65,0,0,1,.492.65,2.139,2.139,0,0,1,.158.833,2.164,2.164,0,0,1-.106.683,1.977,1.977,0,0,1-.307.584,2.069,2.069,0,0,1-.495.46,2.479,2.479,0,0,1-.67.311,1.3,1.3,0,0,1,.237.176,1.246,1.246,0,0,1,.2.24Zm-3.423-3.749a2.055,2.055,0,0,0,.655-.094,1.263,1.263,0,0,0,.46-.259,1.043,1.043,0,0,0,.27-.393,1.356,1.356,0,0,0,.089-.5,1.015,1.015,0,0,0-.359-.836,1.713,1.713,0,0,0-1.1-.292h-.851v2.375Z",
    transform: "translate(-677.898 -291.757)",
    fill: "#05c6a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(253.128 181.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M406.03,217.449h3.618l7.5,11.458V217.449h4.569v18.934h-3.645l-7.5-11.431v11.431H406.03Z",
    transform: "translate(-406.03 -217.271)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M466.6,232.173V221.991a4.1,4.1,0,0,1,1.388-3.483,5.3,5.3,0,0,1,3.312-1.06q4.386.025,8.559.356v3.727h-7.184a1.687,1.687,0,0,0-1.11.33,1.224,1.224,0,0,0-.4,1v2.092l7.4.254v3.472l-7.4.23v1.99a1.51,1.51,0,0,0,.384,1.136,1.362,1.362,0,0,0,.99.37h7.317v3.7a78.837,78.837,0,0,1-8.266.433q-4.992,0-4.993-4.364",
    transform: "translate(-447.876 -217.271)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M519.879,235.373a5.142,5.142,0,0,1-2.656-2.845,20.627,20.627,0,0,1,0-12.032,5.145,5.145,0,0,1,2.656-2.857,14.746,14.746,0,0,1,9.377,0,5.146,5.146,0,0,1,2.653,2.857,20.615,20.615,0,0,1,0,12.032,5.143,5.143,0,0,1-2.653,2.845,14.724,14.724,0,0,1-9.377,0m6.959-3.636a2.533,2.533,0,0,0,1.082-1.646,14.948,14.948,0,0,0,.318-3.572,15.4,15.4,0,0,0-.318-3.65,2.458,2.458,0,0,0-1.068-1.621,4.841,4.841,0,0,0-2.285-.42,4.762,4.762,0,0,0-2.258.42,2.5,2.5,0,0,0-1.082,1.621,14.817,14.817,0,0,0-.331,3.65,14.994,14.994,0,0,0,.316,3.572,2.538,2.538,0,0,0,1.083,1.646,6,6,0,0,0,4.544,0",
    transform: "translate(-482.229 -216.873)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 8.189,
    height: 3.521,
    transform: "translate(52.187 9.951)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M601.849,217.449h4.727l4.119,14.161,4.12-14.161h4.676l-5.969,18.934h-5.706Z",
    transform: "translate(-541.312 -217.271)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 4.57,
    height: 18.934,
    transform: "translate(80.028 0.178)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M690.011,217.449h3.618l7.5,11.458V217.449H705.7v18.934h-3.645l-7.5-11.431v11.431h-4.543Z",
    transform: "translate(-602.219 -217.271)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M752.158,235.373a5.112,5.112,0,0,1-2.364-2.871,17.054,17.054,0,0,1-.833-6.034,16.043,16.043,0,0,1,.859-5.9,5.363,5.363,0,0,1,2.417-2.9,8.464,8.464,0,0,1,3.908-.8,21.134,21.134,0,0,1,3.62.28,14.459,14.459,0,0,1,2.666.688v3.421a30.233,30.233,0,0,0-5.309-.435,4.43,4.43,0,0,0-2.165.422,2.563,2.563,0,0,0-1.083,1.619,14.151,14.151,0,0,0-.343,3.623,16.164,16.164,0,0,0,.291,3.561,2.546,2.546,0,0,0,1.057,1.659,4.374,4.374,0,0,0,2.27.472,39.489,39.489,0,0,0,5.283-.255v3.419a19.788,19.788,0,0,1-6.312.791,8.863,8.863,0,0,1-3.961-.766",
    transform: "translate(-642.946 -216.873)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 4.57,
    height: 18.934,
    transform: "translate(122.046 0.178)",
    fill: "#1b2847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(184.707 164.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(5.314 17.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M201.9,222.745s18.157-1.939,18.439,8.781.372,23.507.372,23.507L222.92,244.1l2.116,10.929.568-23.507s-.9-9.644,18.433-8.918c-7.243-.77-15.332-2.221-21.07.727C220.333,222.246,218.828,220.477,201.9,222.745Z",
    transform: "translate(-201.897 -221.564)",
    fill: "#1b2847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(6.453 10.132)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M245.443,197.725c-14.338,3.33-19.9,9.115-19.932,9.146-.029-.031-5.593-5.816-19.931-9.146,0,0,34.046,10.44,6.675,37.53,0,0,10.822-7.218,13.255-12.226,2.433,5.008,13.255,12.226,13.255,12.226C211.4,208.165,245.443,197.725,245.443,197.725Z",
    transform: "translate(-205.581 -197.725)",
    fill: "#1b2847"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M234.335,210.894v4.63a24.5,24.5,0,1,1-47.243,2.121v-5.581a26.287,26.287,0,0,0,43.288,28.686,26.3,26.3,0,0,0,4.967-7.827,26.278,26.278,0,0,0-1.012-22.029Z",
    transform: "translate(-184.707 -196.691)",
    fill: "#00ddb8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M229.28,166.743a24.377,24.377,0,0,1,15.249,5.345h2.732a26.221,26.221,0,0,0-36.092.125h2.705A24.381,24.381,0,0,1,229.28,166.743Z",
    transform: "translate(-202.988 -164.952)",
    fill: "#00ddb8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M265.795,191.7a3.825,3.825,0,0,0-1.7.4H267.5A3.826,3.826,0,0,0,265.795,191.7Z",
    transform: "translate(-239.55 -183.432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M225.074,193a5.633,5.633,0,0,1,.937,1.791h14.832v40.33H200.5v-40.33h14.738a5.62,5.62,0,0,1,.936-1.791H198.7v43.913h43.93V193Z",
    transform: "translate(-194.377 -184.33)",
    fill: "#1b2847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M262.711,192.1a3.857,3.857,0,1,0,1.765,1.791A3.825,3.825,0,0,0,262.711,192.1Z",
    transform: "translate(-234.762 -183.432)",
    fill: "#1b2847"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNeo);
export default __webpack_public_path__ + "static/media/logo_neo.e99eae0b22a1b1f7a6d7898d6abe94c6.svg";
export { ForwardRef as ReactComponent };